<template>
	<div>
		<footer class="container-fluid py-5">
			<div class="container text-left text-sm-center">
				<ul class="m-0">
					<li>
						<a href="https://ohowatch.com/terms" target="_blank"
							>Terms Of Use</a
						>
					</li>
					<li>
						<a href="https://ohowatch.com/privacy" target="_blank"
							>Privacy Policy</a
						>
					</li>
					<li>
						<a href="https://ohowatch.com/impressum" target="_blank"
							>Impressum</a
						>
					</li>
					<li>
						<a href="https://ohowatch.com/returns" target="_blank"
							>Returns</a
						>
					</li>
					<li>
						<a href="https://ohowatch.com/#about-us" target="_blank"
							>About Us</a
						>
					</li>
					<li>
						<a
							href="https://ohowatch.com/affiliates"
							target="_blank"
							>Affiliates</a
						>
					</li>
				</ul>
				<p class="pl-4 pl-sm-0">
					&copy; 2020 All rights reserved | Oho Pro&trade;
				</p>
				<div class="dmca text-left text-sm-center pl-4 pl-sm-0">
					<a
						class="dmca-badge"
						title="DMCA.com Protection Status"
						href="//www.dmca.com/Protection/Status.aspx?ID=c61cff46-7b88-4720-b1e6-f4e15e92c28a"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src="https://images.dmca.com/Badges/dmca-badge-w150-5x1-06.png?ID=c61cff46-7b88-4720-b1e6-f4e15e92c28a"
							alt="DMCA.com Protection Status"
						/>
					</a>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
</style>